// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__uKAmh","smallBanner":"Banner_smallBanner__gzmEy","verySmallBanner":"Banner_verySmallBanner__jGf66"};